import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs2000',
    ecrans: ['00-2']
});
